import { ProgressorResult } from "src/modules/utils/misc/Progressor-Result";
import { Progressor } from "src/modules/utils/misc/Progressor";
import { RestEndpoint } from "./rest-endpoint.model";
import { SmTimer } from "./sm-timer.model";

export class ProgressorClient {

    static async waitForResult(guid: string, onProgress: (progressor: Progressor) => void): Promise<ProgressorResult> {
        return new Promise((resolve, reject) => {
            let timer: SmTimer;
            timer = new SmTimer("PortalProgressor", 0, 100, async () => {
                try {
                    const progressor = (await RestEndpoint.main().run("api/app/getProgressors").list(Progressor)).find(item => item.guid == guid);
                    if (progressor != null) {
                        onProgress(progressor);
                        return;
                    }

                    timer.destroy();
                    const result = await RestEndpoint.main().query({guid}).run("api/app/getProgressorResult").get(ProgressorResult);
                    if (result.error) {
                        reject(new Error(result.value));
                    }
                    else {
                        resolve(result);
                    }
                }
                catch (error) {
                    timer.destroy();
                    reject(error instanceof Error ? error : new Error(String(error)));
                }
            }, true);
        });
    }
}